import { IServiceDataModel } from "../shared/models/serviceData.model";

export const servicesData: IServiceDataModel = {
  extensions: [
    {
      service: "EXTENSION INSTALL",
      rate: "$250+",
      details:
        "A transformative experience or an experience to simply accentuate your natural hair. Add volume and length to create your dream hair.",
    },
    {
      service: "EXTENSION MAINTENANCE",
      rate: "$200+",
      details:
        "6-8 week recommended maintenance from initial install. This service includes removal of the extensions and re-install. Wash & Style not included. ",
    },
    {
      service: "HAIR- PRICE UPON CONSULTATION",
      rate: "$125+ per weft",
      details:
        "We utilize our in-house extension line, Abundance Extensions, luxury remy hair hand tied wefts, k-tips and tape-ins. Our products are top tier quality that provide ultimate comfort and thickness.",
    },
  ],
  haircuts: [
    {
      service: "MEN'S HAIRCUT",
      rate: "$85+",
      details: "Includes an invigorating wash & styling.",
    },
    {
      service: "WOMEN'S HAIRCUT",
      rate: "$125+",
      details: "Includes blow-dry & style.",
    },
  ],
  styling: [
    {
      service: "KERATIN SMOOTHING TREATMENT",
      rate: "$300+",
      details:
        "Smooth, amp up shine & reduce blow-drying time by sealing your hair's cuticle. Includes blow-dry & style. ",
    },
    {
      service: "BLOW DRY",
      rate: "$85",
      details: "Professional blow-out for smooth, voluminous results. Includes styling to complete your look.",
    },
    {
      service: "Blow Dry (Thick, Curly hair or with Extensions)",
      rate: "$110",
      details: "Extended blow-dry service for thick, curly, or extension-enhanced hair. Includes styling.",
    },
    {
      service: "UP DO/STYLE",
      rate: "$95+",
      details: "Special occasion updo or styled look. Perfect for weddings, events, and photos.",
    },
  ],
  color: [
    {
      service: "Color Maintenance",
      rate: "$150+",
      details: "Grow Out, Root Melt & Gloss, Gloss Refresh. ",
    },
    {
      service: "Highlight",
      rate: "$300+",
      details: "Hand-painted highlights to add dimension, brightness, and depth to your hair. Customized to complement your skin tone and style.",
    },
    {
      service: "Balayage",
      rate: "$300+",
      details: "Freehand highlighting technique for a natural, sun-kissed look. Low-maintenance color that grows out beautifully.",
    },
    {
      service: "Corrective Color  ",
      rate: "",
      details:
        "Corrective service to fix color tones to achieve desired hair. Price Upon Consultation. ",
    },
  ],

  addOns: [
    {
      service: "Kerastase Fusio Dose Treatment",
      rate: "$45",
      details:
        "Composed of two parts, a concentre and a booster, formulated based on your hair goals. Address your main hair concerns and enjoy the benefits of the treatment that last up to 4-6 weeks. ",
    },
    {
      service: "ADDITIONAL BOWLS OF COLOR",
      rate: "$35",
      details: "Extra color bowls for full coverage when more product is needed. Applied per service.",
    },
  ],
};
